import { Alert } from '@material-ui/lab';

import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';

export const SimulatorDisabledAlert = () => {
  const { customBorderRadius } = useCustomTheme();

  return (
    <Alert severity={'info'} icon={<Icon size={22}>{'info'}</Icon>} style={{ borderRadius: customBorderRadius.paper }}>
      <Text tId={'SIMULATOR_DISABLED_AGENT_ACCOUNT'} />
    </Alert>
  );
};
